import * as feEvents from '@dazn/fe-events';


interface NotificationClickEventParams {
    itemName: feEvents.NotificationNameFragment;
    clickedElement: string
}


const triggerNotificationClickEvent = ({ itemName, clickedElement }: NotificationClickEventParams) => {
    feEvents.triggerNotificationClickEvent({
        notification: {
            itemType: 'notification',
            itemName,
            clickedElement,
        },
    });
};

export { triggerNotificationClickEvent }